import React from 'react'
import { useTranslation } from 'react-i18next'

import { useQrcode } from '../../_load/QrcodeLoader'
import Center from '../../../../components/helpers/Center'
import IconBlock from '../../../../components/presentation/IconBlock'

// Quando o local/ativo apontado pelo QR Code foi excluído, a API devolve o QR Code sem `data`.
// Nesse caso mostramos uma mensagem amigável em vez de carregar o menu com ids indefinidos.
const DeactivatedPlaceMessage = ({ children }) => {
  const { t } = useTranslation('qrcodes')
  const qrcode = useQrcode()

  if (qrcode?.data?.id) return children

  return (
    <Center>
      <IconBlock icon="BsExclamationTriangle" title={t('deactivatedPlace')} />
    </Center>
  )
}

export default DeactivatedPlaceMessage
